export enum enumGAProductName {
  ISF = 'ISF',
  ES = 'ES',
  BR = 'Bond Request',
  LCL = 'LCL',
  MI = 'Marine Insurance',
  CBP = 'Assigned CBP Application',
}
